const Roles = {
    operatorBase: 'Operator Base',
    operatorFull: 'Operator Full',
    receptionist: 'Receptionist',
    baseReceptionist: 'Base Receptionist',
    adminGeneral: 'Admin General',
    coordinator: 'Coordinator',
    statistical: 'Statistical',
    supervisor: 'Supervisor',
    sigeci: 'SiGeCi',
    organizationAdmin: 'Organization Admin',
};

export default Roles;
